import React from 'react';
import Hero from './components/omr/Hero';
import Main from './components/omr/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const OMR = () => {
    return (
        <div>
            <Hero />
            <Main />
            <ImportantLinksSlider />
        </div>
    )
}

export default OMR;